<template>
  <div class="table-toolbar">
    <div class="table-toolbar-left">
      <Button v-if="showAddBtn" style="margin-left: 3px" type="success" @click="addNewItem">{{ defaultAddBtnText }}</Button>
      <Button v-if="showEditBtn" style="margin-left: 3px" type="primary" @click="changeViewMode">{{viewText}}</Button>
      <Poptip v-if="showBatchDelBtn" v-model="innerBatchDeleteConfirm"
              confirm
              title="你确定要删除吗?"
              @on-ok="deleteItem">
        <Button style="margin-left: 3px" v-if="showBatchDelBtn" type="error">{{defaultBatchDelText}}</Button>
      </Poptip>
      <slot name="toolBarAction"></slot>
    </div>
    <div class="table-toolbar-right">
      <Form class="form-inline" role="form" :label-width="80" inline @submit.native.prevent>
        <slot name="toolbarSearch"></slot>
        <Input v-if="defaultSearchBox" v-model="searchKey" clearable :placeholder="searchBoxPlaceholder" style="width: 150px;" />
        <Button v-if="defaultSearchBtn" class="search-btn" type="primary" @click="onInnerSearchBtnClick"><Icon type="ios-search"/>&nbsp;&nbsp;搜索</Button>
      </Form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tool-bar-action',
  props: {
    /** *低优先级配置项**/
    showAddBtn: {
      type: Boolean,
      default: true
    },
    defaultAddBtnText: {
      default: '新增'
    },
    showEditBtn: {
      type: Boolean,
      default: true
    },
    showBatchDelBtn: {
      type: Boolean,
      default: true
    },
    defaultSearchBox: {
      type: Boolean,
      default: false
    },
    defaultSearchBtn: {
      type: Boolean,
      default: false
    },
    searchBoxPlaceholder: {
      default: '输入关键字搜索'
    },
    viewText: {
      type: String,
      default: '编辑'
    },
    defaultBatchDelText: {
      type: String,
      default: '删除'
    },
    changeViewMode: {
      type: Function,
      default: () => {}
    },
    deleteItem: {
      type: Function,
      default: () => {}
    },
    onSearchBtnClick: {
      type: Function,
      default: () => {}
    },
    addNewItem: {
      type: Function,
      default: () => {}
    },
    batchDeleteConfirm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchKey: ''
    }
  },
  computed: {
    innerBatchDeleteConfirm: {
      get () {
        return this.batchDeleteConfirm
      },
      set (val) {
        this.$emit('update:value', val)
      }
    }
  },
  methods: {
    onInnerSearchBtnClick () {
      this.onSearchBtnClick(this.searchKey)
    }
  }
}
</script>

<style scoped>
@import url('./edit-table.css');

</style>
